import React from "react";
import { FaRegEnvelope } from "react-icons/fa6";
import "./Contact.css";

const Contact = () => {
  return (
    <>
      <h1 className="Contact-Title">CONTACT</h1>
      <h1 className="Contact-Subtitle">Tell me about your next project!</h1>
      <button
        className="Contact-Button"
        onClick={() =>
          (window.location.href = "mailto:shoqibulatzmi@gmail.com")
        }
      >
        Get In Touch <FaRegEnvelope />
      </button>
    </>
  );
};

export default Contact;
